<template>
  <div>
    <view-header header="Mapa strony" />
    <div class="content">
      <ul>
        <li>
          <router-link class="the-nav__item" :to="{ name: 'live' }" exact>Transmisja online</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'videos' }" exact>Archiwum nagrań</router-link>
          <ul>
            <li v-for="video in videos" v-bind:key="video">
              <router-link
                :key="video.id"
                class="the-nav__item"
                :to="{ name: 'video', params: { id: video.id } }"
                exact
              >{{ video.title }} </router-link>
            </li>
          </ul>
        </li>
        <li v-for="page of pages" v-bind:key="page">
          <component
            :is="page.external ? 'a' : 'router-link'"
            :key="page.id"
            :href="page.external ? page.url : null"
            :to="page.external ? null : { name: 'page', params: { slug: page.url } }"
            :target="page.external ? '_blank' : '_self'"
            :aria-label="page.title"
            exact
          >
            {{ page.title }}
          </component>
        </li>
        <li v-for="video in videos" v-bind:key="video">
          <router-link
            :key="video.id"
            class="the-nav__item"
            :to="{ name: 'video', params: { id: video.id } }"
            exact
          >{{ video.title }} </router-link>
        </li>
        <li><a :href="adminPanelUrl" class="the-nav__item">Zaloguj się</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import ViewHeader from '../components/ViewHeader';
  import { PortalService } from '../utils/portal-service';

  export default {
    name: 'SiteMap',
    components: { ViewHeader },
    metaInfo: {
      meta: [
        { title: 'Portal | Mapa strony' },
        { description: 'Portal | Mapa strony' },
      ],
    },
    data() {
      return {
        videos: null,
        pages: [],
      };
    },
    computed: {
      adminPanelUrl() {
        return `${window.location.origin}/panel/login`;
      },
    },
    created() {
      PortalService.getRecordings().then(res => {
        this.videos = res.data['hydra:member'].slice(0, 5);
      });

      PortalService.getPages().then(res => {
        this.pages = res.data['hydra:member'];
      });
    },
  };
</script>

<style lang="scss">
  .content {
    a {
      cursor: pointer;
      color: #333333;
      font-weight: normal;
      font-size: 1rem;
      &:hover {
        color: #b61f1f;
      }
    }
    ul {
      margin-left: 2rem;
      ul {
        margin-left: 1rem;
      }
    }
  }
</style>
